module.exports = __webpack_public_path__ + "img/australia.36adb54.webp";